import React, { FC } from "react";
import { ApolloProvider } from "@apollo/client";
import { EnvNames } from "Shared/env/envNames";
import createApolloClient from "./ApolloClient";
type Props = {
  graphQLEndpoint: string;
  environment: EnvNames;
};

const GraphQlClientProvider: FC<Props> = ({
  children,
  graphQLEndpoint,
  environment,
}) => {
  const client = createApolloClient(graphQLEndpoint, environment);
  return (
    <ApolloProvider client={client}>{children}</ApolloProvider>
  );
};

export default GraphQlClientProvider;
